import { DrawerWithCustomContent as AntdDrawerWithCustomContent } from "@empglabs/backoffice-ui-kit"
import { forwardRef } from "react"

export const DrawerWithCustomContent = forwardRef((props, ref) => {
  return <AntdDrawerWithCustomContent ref={ref} {...props} />
})
